import axios from 'axios'

const isNewVersion = () => {
  var url = `//${window.location.host}/version.json?t=${new Date().getTime()}`
  axios.get(url).then(res => {
    if (res.status === 200) {
      let vueVersion = res.data.version
      let localVueVersion = localStorage.getItem('vueVersion')
      if (localVueVersion && localVueVersion != vueVersion) {
        localStorage.setItem('vueVersion', vueVersion)
        localStorage.setItem('versionChanged', true)
        window.location.reload(true)
        return
      } else {
        localStorage.setItem('vueVersion', vueVersion)
      }

      if (res.data.isUnderMaintenance) {
        localStorage['maintenanceUntil'] = res.data.maintenanceUntil
        window.vm.$router.push({ path: '/503' })
      } else {
        localStorage['maintenanceUntil'] = undefined
      }
    }
  })
}

export default {
  isNewVersion
}
